/* eslint-disable sonarjs/no-duplicate-string */
import type { ScreenBase } from "@frui.ts/screens";
import { Router } from "@frui.ts/screens";
import { Modules } from "../../config";
import LocalizationService from "services/localizationService";
import AppRouter from "services/router";
import SecurityService from "services/securityService";
import AccountingTemplatesViewModel from "./accountingTemplates/accountingTemplatesViewModel";
import BankAccountBlacklistsViewModel from "./bankAccountBlacklists/bankAccountBlacklistsViewModel";
import BankAccountsViewModel from "./bankAccounts/bankAccountsViewModel";
import CreditExposuresViewModel from "../timeCharges/distributors/creditExposures/creditExposuresViewModel";
import ExpensesAndRevenuesReportsViewModel from "./expensesAndRevenuesReports/expensesAndRevenuesReportsViewModel";
import PayGateTransactionsViewModel from "./payGateTransactions/payGateTransactionsViewModel";
import PaymentsPairingViewModel from "./paymentsPairing/paymentsPairingViewModel";
import RefundApprovalsViewModel from "./refundApprovals/refundApprovalsViewModel";
import RefundForRefundOfRefundsViewModel from "./refundForRefundOfRefunds/refundForRefundOfRefundsViewModel";
import OutgoingPaymentsViewModel from "./outgoingPayments/outgoingPaymentsViewModel";
import BankExportViewModel from "./bankExports/bankExportViewModel";
import ModuleViewModel from "../moduleViewModel";
import TurnoutCheckoutsViewModel from "./turnoverCheckouts/turnoverCheckoutsViewModel";
import InternalTransfersViewModel from "./internalTransfers/internalTransfersViewModel";
import AccountingDocumentsApprovalsViewModel from "./accountingDocumentsApprovals/accountingDocumentsApprovalsViewModel";
import UnreturnedRefundOfRefundsViewModel from "./unreturnedRefundsOfRefunds/unreturnedRefundOfRefundsViewModel";
import CustomerRefundsViewModel from "./customerRefunds/customerRefundsViewModel";
import SubLedgerViewModel from "./subLedger/SubLedgerViewModel";
import PaymentsViewModel from "./payments/paymentsViewModel";
import InventoryViewModel from "./accountingInventory/inventoryViewModel";

@Router.registerRoute({
  route: Modules.finance,
  name: Router.Self,
  children: [
    AccountingDocumentsApprovalsViewModel,
    AccountingTemplatesViewModel,
    BankAccountsViewModel,
    CreditExposuresViewModel,
    BankExportViewModel,
    PaymentsPairingViewModel,
    CustomerRefundsViewModel,
    RefundApprovalsViewModel,
    RefundForRefundOfRefundsViewModel,
    BankAccountBlacklistsViewModel,
    TurnoutCheckoutsViewModel,
    InternalTransfersViewModel,
    InventoryViewModel,
    ExpensesAndRevenuesReportsViewModel,
    UnreturnedRefundOfRefundsViewModel,
  ],
})
export default class FinanceViewModel extends ModuleViewModel<ScreenBase> {
  protected readonly module = Modules.finance;

  // eslint-disable-next-line sonarjs/cognitive-complexity
  constructor(
    protected localizationService: LocalizationService,
    private securityService: SecurityService,
    private appRouter: AppRouter,
    private bankAccountsViewModel: BankAccountsViewModel,
    private accountingTemplatesViewModel: AccountingTemplatesViewModel,
    private accountingDocumentsApprovalsViewModel: AccountingDocumentsApprovalsViewModel,
    private customerRefundsViewModel: CustomerRefundsViewModel,
    private refundApprovalsViewModel: RefundApprovalsViewModel,
    private refundForRefundOfRefundsViewModel: RefundForRefundOfRefundsViewModel,
    private bankAccountBlacklistsViewModel: BankAccountBlacklistsViewModel,
    private outgoingPayments: OutgoingPaymentsViewModel,
    private paymentsPairingViewModel: PaymentsPairingViewModel,
    private bankExportViewModel: BankExportViewModel,
    private subLedgerViewModel: SubLedgerViewModel,
    private turnoutCheckoutsViewModel: TurnoutCheckoutsViewModel,
    private internalTransfersViewModel: InternalTransfersViewModel,
    private payGateTransactionsViewModel: PayGateTransactionsViewModel,
    private paymentsViewModel: PaymentsViewModel,
    private inventoryViewModel: InventoryViewModel,
    private expensesAndRevenuesReportsViewModel: ExpensesAndRevenuesReportsViewModel,
    private unreturnedRefundsOfRefunds: UnreturnedRefundOfRefundsViewModel
  ) {
    super();
    this.navigationName = this.module;

    if (this.securityService.allowToEntity("bankAccountEnum")) {
      this.children.push(this.bankAccountsViewModel);
    }

    if (this.securityService.allowTo("finance")) {
      this.children.push(this.accountingTemplatesViewModel);
    }

    if (
      this.securityService.allowTo("finance") &&
      (this.securityService.allowTo("finance.commandoperating") || this.securityService.allowTo("finance.chiefaccounting"))
    ) {
      this.children.push(this.accountingDocumentsApprovalsViewModel);
    }

    if (this.securityService.allowTo("finance") || this.securityService.allowTo("callcenter.finance")) {
      this.children.push(this.customerRefundsViewModel);
      this.children.push(this.refundApprovalsViewModel);
    }

    if (this.securityService.allowTo("finance")) {
      this.children.push(this.refundForRefundOfRefundsViewModel);
    }

    if (this.securityService.allowTo("finance.reports")) {
      this.children.push(this.unreturnedRefundsOfRefunds);
    }

    if (this.securityService.allowToEntity("bankAccountBlacklist")) {
      this.children.push(this.bankAccountBlacklistsViewModel);
    }

    if (this.securityService.allowTo("finance")) {
      this.children.push(this.bankExportViewModel);
    }

    if (this.securityService.allowTo("finance.reports")) {
      this.children.push(this.subLedgerViewModel);
    }

    if (
      this.securityService.allowTo("finance") ||
      (this.securityService.allowTo("finance.reports") && this.securityService.allowTo("finance")) ||
      this.securityService.allowTo("callcenter")
    ) {
      this.children.push(this.outgoingPayments);
    }
    if (this.securityService.allowTo("finance") || this.securityService.allowTo("callcenter.finance")) {
      this.children.push(this.paymentsViewModel);
    }
    if (this.securityService.allowTo("finance.chiefaccounting") || this.securityService.allowTo("finance.accountingofficer")) {
      this.children.push(this.inventoryViewModel);
    }
    if (
      this.securityService.allowTo("finance") ||
      this.securityService.allowTo("callcenter") ||
      this.securityService.allowTo("callcenter.finance")
    ) {
      this.children.push(this.paymentsPairingViewModel);
    }

    if (this.securityService.allowTo("finance.reports")) {
      this.children.push(this.turnoutCheckoutsViewModel);
    }

    if (this.securityService.allowTo("finance")) {
      this.children.push(this.internalTransfersViewModel);
    }

    if (this.securityService.allowToEntity("payGateTransaction")) {
      this.children.push(this.payGateTransactionsViewModel);
    }

    if (this.securityService.allowTo("finance.reports")) {
      this.children.push(this.expensesAndRevenuesReportsViewModel);
    }
  }
}
